// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3d8bc","title":"FrontImage_title__3qeU6"};